exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".link-chip[data-v-d3cf2722]{white-space:normal;word-break:break-all}.payment-container[data-v-d3cf2722]{border-radius:10px;border:1px solid rgba(0,0,0,.38);padding:20px}", ""]);

// exports
